module.exports = __webpack_public_path__ + "img/tips-rest-icon.385ee4b8.svg";